import { ClientContract } from "@dune/types";
import { formatCurrency, getPropositionStatusLabel } from "@dune/utils";
import { ColumnDef } from "@tanstack/react-table";

export const contractsColumns = (): ColumnDef<ClientContract>[] => [
	{
		accessorKey: "reference",
		header: "Référence",
		cell: ({ row }) => (
			<div className="font-medium">{row.getValue("reference")}</div>
		),
	},
	{
		accessorKey: "contractNumber",
		header: "N° Contrat",
		cell: ({ row }) => {
			const contractNumber = row.original.contractNumber;
			return contractNumber ? (
				<div className="font-medium">{contractNumber}</div>
			) : (
				<div className="text-gray-400">-</div>
			);
		},
	},
	{
		accessorKey: "status",
		header: "Statut",
		cell: ({ row }) => {
			const status = row.original.status;
			return (
				<div className="font-medium">{getPropositionStatusLabel(status)}</div>
			);
		},
	},
	{
		accessorKey: "productType",
		header: "Type de produit",
		cell: ({ row }) => (
			<div className="font-medium">{row.getValue("productType")}</div>
		),
	},
	{
		accessorKey: "assureurName",
		header: "Assureur",
		cell: ({ row }) => (
			<div className="font-medium">{row.getValue("assureurName")}</div>
		),
	},
	{
		accessorKey: "primeTTC",
		header: "Prime TTC",
		cell: ({ row }) => {
			const primeTTC = row.original.primeTTC;
			return <div className="font-medium">{formatCurrency(primeTTC)}</div>;
		},
	},
	{
		accessorKey: "contractStartDate",
		header: "Date début",
		cell: ({ row }) => {
			const startDate = row.original.contractStartDate;
			return startDate ? (
				<div className="font-medium">
					{new Date(startDate).toLocaleDateString("fr-FR")}
				</div>
			) : (
				<div className="text-gray-400">-</div>
			);
		},
	},
	{
		accessorKey: "contractEndDate",
		header: "Date fin",
		cell: ({ row }) => {
			const endDate = row.original.contractEndDate;
			return endDate ? (
				<div className="font-medium">
					{new Date(endDate).toLocaleDateString("fr-FR")}
				</div>
			) : (
				<div className="text-gray-400">-</div>
			);
		},
	},
	{
		accessorKey: "signedAt",
		header: "Signé le",
		cell: ({ row }) => {
			const signedAt = row.original.signedAt;
			return signedAt ? (
				<div className="font-medium">
					{new Date(signedAt).toLocaleDateString("fr-FR")}
				</div>
			) : (
				<div className="text-gray-400">-</div>
			);
		},
	},
	{
		accessorKey: "constructionSite.address",
		header: "Adresse",
		cell: ({ row }) => {
			const address = row.original.constructionSite.address;
			return address ? (
				<div className="font-medium">{address}</div>
			) : (
				<div className="text-gray-400">-</div>
			);
		},
	},
];
